import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Router, RouterModule, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../pages/public/home/header/header.component';
import { FooterComponent } from '../../pages/public/home/footer/footer.component';
import { TranslocoModule } from '@ngneat/transloco';
import { CommonModule } from '@angular/common';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { Commons } from '../../shared/Commons';
import { ClientBrowserSessionStorageService } from '../../services/client-browser-session-storage.service';
import { OwnerConfig } from '../../shared/interfaces/core/owner-config';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-public-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    CommonModule,
    RouterModule,
    TranslocoModule,
  ],
  templateUrl: './public-layout.component.html',
  styleUrl: './public-layout.component.scss'
})
export class PublicLayoutComponent implements OnInit {

  ownerDetail: OwnerConfig = Commons.emptyOwnerConfig()
  chat_button: any = {
    ws: {
      enabled: false,
      type: '',
      initial_text: ''
    }
  }
  constructor(
    private sessionStorageService: ClientBrowserSessionStorageService,
    private router: Router,
    private analyticsService: GoogleAnalyticsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.ownerDetail = (Commons.getOwner(this.sessionStorageService) != null) ? Commons.getOwner(this.sessionStorageService).config : Commons.getDefaultConfig()
      const body = document.querySelector('body');
      if (environment.withBackgroundBody) {
        body?.classList.add('with-bg');
      } else {
        body?.classList.remove('with-bg');
      }
      this.chat_button = environment.chat_button
      this.chat_button.ws.initial_text = this.chat_button.ws.initial_text.replace('_COMPANY_WEB_', this.getWebSiteLabel)
    }
  }

  get isBrowser() {
    return Commons.isBrowser(this.platformId);
  }

  get getWebSiteLabel() {
    const baseUrl = environment.baseUrl
    const siteLabel = typeof baseUrl === 'string' ? baseUrl.replace(/^https?:\/\/(www\.)?/i, '') : ''
    return siteLabel
  }

  openWhatsAppAndTrack(): void {
    const currentPath = this.router.url;
    // 1. Log de evento en Google Analytics
    this.analyticsService.logEvent('click_whatsapp', {
      button_name: 'whatsapp_contact',
      page: currentPath
    });

    // 2. Log de conversión en Google Ads
    this.analyticsService.logConversion();

    const message = encodeURIComponent(this.chat_button.ws.initial_text);
    const phone = this.chat_button.ws.phone;
    const url = `https://wa.me/${phone}?text=${message}`;
    window.open(url, '_blank');
  }
}
